import { useBrokerContext } from '@/app/context';
import { BrokerInactiveNotice } from '@/features/brokers/components/broker-inactive-notice.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { PoliciesContent } from '../../../features/policies/components';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/policies/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.emissions.read',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { selectedBroker } = useBrokerContext();
  const policyActionGuard = useSelectedBrokerWriteGuard('policy', 'other');

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Apólices', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Apólices</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe, envie e gerencie as apólices
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <BrokerInactiveNotice guards={[policyActionGuard]} />

      <PoliciesContent selectedBroker={selectedBroker} />
    </Page.Root>
  );
}
